export default {
    'name': 'play_m',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path d=\'M52.7865 29.408C54.7729 30.5652 54.7729 33.435 52.7865 34.5923L18.8192 54.3816C16.8192 55.5468 14.309 54.1041 14.309 51.7894L14.309 12.2108C14.309 9.89615 16.8192 8.45344 18.8192 9.61863L52.7865 29.408Z\' fill=\'#026958\'/>'
}
